// extracted by mini-css-extract-plugin
export var cardHeader = "_dj-0";
export var reorderHandle = "_dj-3";
export var titleArea = "_dj-1";
export var titleAreaWithHandle = "_dj-2";